import 'whatwg-fetch';

type mainApi = () => Promise<Response>;

export function mainApi(apiUrl: string, method: string = 'GET', body: object = {}, headers: object = {}, includeCredentials : bool = false): mainApi {
	return () => {
		var args = {
			method: method,
			headers: headers
		};

		if ( true === includeCredentials ) {
			args.credentials = 'include'
		}

		if (method === 'POST' || method === 'PUT') {
			args = {
				...args,
				body: JSON.stringify(body)
			};
		}


		return fetch( apiUrl, args )
		.catch((error) => {
			console.log('An error occurred. Please try again later');
		})
		.then((response) => {
			if (!response.ok) {
				console.log(response.statusText);
			}
			return response.json();
		})
		.then((json) => json);
	};
}
